"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
exports.__esModule = true;
exports.present = void 0;
__exportStar(require("./semaphore"), exports);
__exportStar(require("./limiter"), exports);
__exportStar(require("./promisify"), exports);
__exportStar(require("./throttle"), exports);
__exportStar(require("./recurring"), exports);
__exportStar(require("./wait"), exports);
__exportStar(require("./waitUntil"), exports);
__exportStar(require("./timeout"), exports);
__exportStar(require("./memo"), exports);
/**
 * Equivalent to Ruby's "present?" method, with Typescript niceties.
 * @example
 *   const a: Array<string | undefined | null> = ['', undefined, null, 'a', 'b']
 *   const b: string[] = a.filter(present) // ['a', 'b']
 * @param value
 */
function present(value) {
    if (typeof value == 'string') {
        return value ? value.length > 0 && /\S/.test(value) : false;
    }
    if (typeof value == 'number') {
        return value != 0;
    }
    return !!value;
}
exports.present = present;
//# sourceMappingURL=index.js.map